/* eslint-disable no-param-reassign */
import Vue from 'vue';
import mergeWith from 'lodash-es/mergeWith';
import isArray from 'lodash-es/isArray';
import mutations from './mutationlist';

/* eslint no-param-reassign: [
  "error", { "props": true, "ignorePropertyModificationsFor": ["state"] }
] */
export default {
  [mutations.SET_DEEP]: (state, { key, value }) => {
    state = mergeWith(
      state,
      key.split('.').reverse().reduce((o, i) => ({ [i]: o }), value),
      (objValue, srcValue) => {
        if (isArray(srcValue)) {
          return srcValue;
        }

        return undefined;
      },
    );
  },
  [mutations.MENU_LEFT]: (state, payload) => {
    Vue.set(state, 'left_menu', payload);
  },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js